export default __webpack_public_path__ + "static/media/amaze-17.5e4510d3.jpg";